import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import PropTypes from 'prop-types';

const accessLevelOrder = ['public_access', 'low', 'medium', 'high'];

function leadAccessGreaterThan(levelToTest, leadAccessLevel) {
  return accessLevelOrder.indexOf(leadAccessLevel) >= accessLevelOrder.indexOf(levelToTest);
}

function completedNecessaryPriorSteps(useVaultGates, waitlistApproved, profileComplete, verified, signed) {
  return useVaultGates || (waitlistApproved && profileComplete && verified && signed);
}

function getAccessLevelClassWithFallback(stepsForDocumentCenterAccess, accessLevelChecking, leadAccessLevel) {
  if (stepsForDocumentCenterAccess && leadAccessGreaterThan(accessLevelChecking, leadAccessLevel)) {
    return `${accessLevelChecking}-access`;
  }

  return 'not-completed';
}

function iconClassAndTextForStep({
  leadAccessLevel,
  profileComplete,
  signed,
  step,
  useVaultGates,
  verified,
  waitlistApproved
}) {
  const stepsForDocumentCenterAccess = completedNecessaryPriorSteps(useVaultGates, waitlistApproved,
    profileComplete, verified, signed);
  switch (step) {
  case 'public_access': {
    const iconClassName = leadAccessGreaterThan('public_access', leadAccessLevel) ? 'public-access' : 'not-completed';
    return { boxText: 'Public Documents', iconClassName };
  }
  case 'low': {
    const iconClassName = getAccessLevelClassWithFallback(stepsForDocumentCenterAccess, 'low', leadAccessLevel);
    return { boxText: 'Low Documents', iconClassName };
  }
  case 'medium': {
    const iconClassName = getAccessLevelClassWithFallback(stepsForDocumentCenterAccess, 'medium', leadAccessLevel);
    return { boxText: 'Medium Documents', iconClassName };
  }
  case 'high': {
    const iconClassName = getAccessLevelClassWithFallback(stepsForDocumentCenterAccess, 'high', leadAccessLevel);
    return { boxText: 'High Documents', iconClassName };
  }
  case 'collect_information':
  case 'registration':
    return { boxText: 'Created Profile', iconClassName: profileComplete ? 'created-profile' : 'not-completed' };
  case 'verification':
    return { boxText: 'Verified Email', iconClassName: verified ? 'verified-email' : 'not-completed' };
  case 'sign_ca':
    return { boxText: 'Signed CA', iconClassName: signed ? 'signed-ca' : 'not-completed' };
  case 'waitlist':
    return { boxText: 'Waitlist Approved', iconClassName: waitlistApproved ? 'waitlisted' : 'not-completed' };
  }
}

export default function Step(props) {
  const { iconClassName, boxText } = iconClassAndTextForStep(props);

  return (
    <div className="box d-flex justify-content-center align-items-center gap-2">
      <FontAwesomeIcon className={iconClassName} fixedWidth icon={faCheckCircle} />
      {boxText}
    </div>
  );
}

Step.propTypes = {
  leadAccessLevel: PropTypes.string.isRequired,
  profileComplete: PropTypes.bool.isRequired,
  signed: PropTypes.bool.isRequired,
  step: PropTypes.string.isRequired,
  useVaultGates: PropTypes.bool.isRequired,
  verified: PropTypes.bool.isRequired,
  waitlistApproved: PropTypes.bool.isRequired,
};
